<form [formGroup]="form">

<h4 mat-dialog-title>{{data.title}}</h4>
<mat-dialog-content fxLayout="column">
  <mat-form-field fxFlex>
    <input type="text" matInput placeholder="Filter..." formControlName="searchText" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
  <mat-list class="item-list" dense style="max-height: 200px; overflow:hidden; overflow-y:auto">
    <mat-list-item
      formArrayName="boxes"
      *ngFor="let item of libraryItems | filterUserLibrary: controls.searchText.value; let i = index"
    >
      <template-library-item matLine [label]="item.type" [title]="item.item.name" >
        <mat-checkbox [formControlName]="i" >
        </mat-checkbox>
      </template-library-item>
      </mat-list-item>
  </mat-list>

</mat-dialog-content>
<mat-dialog-actions>
  <button *ngFor="let btn of data.buttons; let i = index"
    mat-raised-button color="primary"
    (click)="buttonClick(i)"
  >
    {{btn.label}}
  </button>
  <div fxFlex></div>
  <button mat-raised-button (click)="cancel()">Cancel</button>
  <button mat-raised-button [disabled]="!selected" color="primary" (click)="addSelected()">
    Add
  </button>
</mat-dialog-actions>
</form>
